import { dropDareDifficultyLevelEnum } from 'root/src/shared/constants/dropEvent';
export const MOCK_QUERY_PARAM = 'mock';
// True only when the page URL carries `?mock=1`. Reads the live location so it stays off by default.
export const isMockReviewClipEnabled = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return new URLSearchParams(window.location.search).get(MOCK_QUERY_PARAM) === '1';
};
const youtube = (id) => `https://www.youtube.com/watch?v=${id}`;
const youtubeThumb = (id) => `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
const mockDelivery = {
    videoURL: youtube('aqz-KE-bpKQ'),
    thumbnail: youtubeThumb('aqz-KE-bpKQ'),
    clipTitle: 'Beating the boss with one health bar left',
    timeStamp: '00:02:14',
    notesForReviewer: 'The dare is completed around the 2 minute mark, right after the second checkpoint.',
    created: '2026-06-09T12:00:00.000Z',
};
export const MOCK_EXAMPLES = [
    {
        videoURL: youtube('ScMzIvxBSi4'),
        thumbnail: youtubeThumb('ScMzIvxBSi4'),
        clipTitle: 'Approved example one',
        timeStamp: '00:00:30',
        created: '2026-06-01T10:00:00.000Z',
    },
    {
        videoURL: youtube('eRsGyueVLvQ'),
        thumbnail: youtubeThumb('eRsGyueVLvQ'),
        clipTitle: 'Approved example two',
        timeStamp: '00:01:05',
        created: '2026-06-02T10:00:00.000Z',
    },
];
// Only the fields the redesign UI reads are meaningful; the rest of SerializedProject is cast away
// because this is throwaway preview data.
export const MOCK_PROJECT = {
    id: 'mock-project-id',
    title: 'Clear the Nightmare difficulty without dying',
    description: 'Stream yourself completing the Nightmare difficulty boss rush from start to finish without a single death.',
    deliveries: [mockDelivery],
};
export const MOCK_REMAINING = 4;
export const MOCK_STREAM_TIME_MINUTES = 0;
export const MOCK_DARE_LEVEL = dropDareDifficultyLevelEnum.medium;
// Pending-review count shown on the navbar "Clips" badge when `?mock=1` is active.
export const MOCK_PENDING_REVIEWS = 3;
export const MOCK_REVIEWER_STATS = {
    totalReviews: 128,
    avgCorrectDecisions: 96,
    avgTimeSpentPerReviewFormatted: '2m 18s',
    extraDares: {
        milestone: 25,
        balance: 6,
        neededForNextMilestone: 3,
    },
};
